import { render } from "./FormAuthModal.vue?vue&type=template&id=49e144ca"
import script from "./FormAuthModal.vue?vue&type=script&lang=js"
export * from "./FormAuthModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__